import { v4 as uuidv4 } from "uuid";

export const addRecord = (currentData, updateCallback, recordTemplate = {}) => {
  const newRecord = {
    id: uuidv4(),
    ...recordTemplate,
  };
  const newData = [...currentData, newRecord];
  updateCallback(newData);
};

export const handleMoveUp = (props, currentData, updateCallback) => {
  const newListData = [...currentData];

  const index = props.dataIndex;

  if (index > 0) {
    // Swap positions
    const tempListData = newListData[index - 1];
    newListData[index - 1] = newListData[index];
    newListData[index] = tempListData;

    // Swap id values
    const tempId = newListData[index - 1].id;
    newListData[index - 1].id = newListData[index].id;
    newListData[index].id = tempId;
  }

  updateCallback([...newListData]);
};

export const handleMoveDown = (props, currentData, updateCallback) => {
  const newListData = [...currentData];

  const index = props.dataIndex;

  // Check if the item is not the last one
  if (index < newListData.length - 1) {
    // Swap positions
    const tempListData = newListData[index + 1];
    newListData[index + 1] = newListData[index];
    newListData[index] = tempListData;

    // Swap id values
    const tempId = newListData[index + 1].id;
    newListData[index + 1].id = newListData[index].id;
    newListData[index].id = tempId;
  }

  updateCallback([...newListData]);
};

